import {
  DECOR_LIBRARY_CATEGORY_SPECS,
  type DecorLibraryCategory,
  type DecorLibraryItem,
} from '@peles/shared';
import { EntityModal } from '../common';
import { DecorLibraryBrowser } from './DecorLibraryBrowser';

export interface DecorLibraryPickerModalProps {
  open: boolean;
  onClose: () => void;
  category: DecorLibraryCategory;
  /** What it is being chosen for: "the whole plan", "Table 4". */
  forWhat: string;
  selectedId?: string | null;
  onPick: (item: DecorLibraryItem) => void;
}

/** Choose one piece of a category from the decor library, with its filters. */
export function DecorLibraryPickerModal({
  open,
  onClose,
  category,
  forWhat,
  selectedId,
  onPick,
}: DecorLibraryPickerModalProps) {
  return (
    <EntityModal
      open={open}
      onClose={onClose}
      title={`${DECOR_LIBRARY_CATEGORY_SPECS[category].label} for ${forWhat}`}
      size="xl"
      overlayClassName="z-[55]"
    >
      {open && (
        <DecorLibraryBrowser
          mode="pick"
          categories={[category]}
          initialCategory={category}
          selectedId={selectedId}
          onPick={(item) => {
            onPick(item);
            onClose();
          }}
        />
      )}
    </EntityModal>
  );
}
